module.exports = __webpack_public_path__ + "static/media/Monferno_gaussian2.914182f9.png";